function renderHTML(element, _ref, styleProp, projection) {
  var style = _ref.style,
    vars = _ref.vars;
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  // Loop over any CSS variables and assign those.
  for (var key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}
export { renderHTML };